import { Box } from '@chakra-ui/react';
import { FC, PropsWithChildren } from 'react';

import { createUseVariantStyle } from '@bonusly/ds-hooks';
import { rem } from '@bonusly/ds-utils';

import { useAvatarContext } from '../lib/context';

const useVariantStyle = createUseVariantStyle({
	size: {
		sm: {
			boxSize: rem(30),
		},
		md: {
			boxSize: rem(38),
		},
		lg: {
			boxSize: rem(44),
		},
		xl: {
			boxSize: rem(52),
		},
		'2xl': {
			boxSize: rem(68),
		},
	},
});

export const AvatarImageWrapper: FC<PropsWithChildren> = ({ children }) => {
	const { bg, size, variant } = useAvatarContext();
	const style = useVariantStyle({ size });

	return (
		<Box
			{...(variant === 'outline' && {
				borderColor: bg,
				...style,
			})}
		>
			{children}
		</Box>
	);
};

AvatarImageWrapper.displayName = 'AvatarImageWrapper';
